<template>
  <div class="rootDiv">
    <Tabs>
      <Tab title="各省景区" label="">
        <div v-for="item in ProvinceList" :key="item.jQSF" style="margin-left: -0.5rem;margin-right: -0.5rem">
          <div class="title-div" style="position: relative">
            <span style="margin-top: 1rem">{{ item.jQSF }}</span>
            <span>{{ '（' + item.viewList.length + '个）' }}</span>
            <img src="../../../../assets/images/32/map.png" alt="" width="24" height="24"
                 @click="GoMap(item.viewList)"
                 style="position: absolute;top: 50%;bottom: 50%;margin: auto">
          </div>
          <Cell :title="view.jQMC"
                v-for="view in item.viewList"
                :key="view.iD" class="cellstyle"
                v-on:click.native="Go(view)"
                :is-link="true">
            <span style="color: #2986de">{{ view.pDNF }}</span>
          </Cell>
        </div>
      </Tab>
      <Tab title="景区地图" label="">
        <ScenicSpot></ScenicSpot>
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import {Indicator, Cell} from "mint-ui";
import {Tab, Tabs} from "vant";
import ScenicSpot from "@/components/menu/tools/View/ScenicSpot";

export default {
  name: "ViewGroup",
  components: {
    ScenicSpot,
    Tab, Tabs, Cell
  },
  mounted() {
    this.getViewListByProvince()
  },
  data() {
    return {
      ProvinceList: [],
      CommonList: [],
      token: localStorage.getItem('token'),
      getViewListByProvinceUrl: '/api/whhly/getViewListByProvince',
    }
  },
  methods: {
    GoMap(viewList) {
      let list = []
      viewList.forEach(x => {
        let point = {title: x.jQMC, data: x}
        list.push(point)
      })
      this.$router.push({name: 'm_view', query: {point: list}})
    },
    Go(item) {
      this.$router.push({name: 'm_view_details', params: {viewModel: item}})
    },
    getViewListByProvince() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getViewListByProvinceUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.ProvinceList = response.data['responseData']
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.cellstyle {
  text-align: left;
}

.rootDiv {
  margin-top: -0.5rem;
}

.title-div {
  background-color: #8450C5;
  padding-top: 5px;
  padding-bottom: 5px;

  span {
    font-size: 1.4rem;
    color: white;
  }
}
</style>
